import { render } from "./AddressFields.vue?vue&type=template&id=13947f72&scoped=true"
import script from "./AddressFields.vue?vue&type=script&lang=js"
export * from "./AddressFields.vue?vue&type=script&lang=js"

import "./AddressFields.vue?vue&type=style&index=0&id=13947f72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13947f72"]])

export default __exports__